import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = {
  class: "tab-title"
};
const _hoisted_4 = ["innerHTML"];
import { ref, onMounted, onUnmounted, watch } from 'vue';
import DOMPurify from 'dompurify';
import { useRouter, useRoute } from 'vue-router';
import { getServerImage, processHtmlImages } from '@/utils/images';
export default {
  __name: 'index',
  props: {
    serviceList: {
      type: Array,
      required: true
    },
    tabHeight: {
      type: Number,
      default: 208
    },
    defaultTab: {
      type: String,
      default: '4'
    },
    showContent: {
      type: Boolean,
      default: true
    }
  },
  emits: ['tab-change'],
  setup(__props, {
    emit: __emit
  }) {
    const router = useRouter();
    const route = useRoute();
    const remark = ref('');
    // 标志位：是否已经完成初始化
    const isInitialized = ref(false);
    // 接收父组件传递的 props
    const props = __props;
    // 直接从路由参数获取初始值（转为字符串）
    const activeTab = ref('');
    const handleTabChange = name => {
      const item = props.serviceList.find(item => item.id === parseInt(name));
      // console.log('handleTabChange item: ', item)

      remark.value = DOMPurify.sanitize(processHtmlImages(item?.remark));
      emit('tab-change', item);
      // 向父组件传递完整的 item 对象
      // 只有在初始化完成后且在详情页时才跳转回根路由
      if (isInitialized.value && route.params.id) {
        router.push('/scenic');
      }
    };
    watch(() => props.defaultTab, newVal => {
      console.log('watch defaultTab: ', newVal);
      activeTab.value = String(newVal);
    });

    // 监听 props.defaultTab 的变化
    watch(() => activeTab.value, newVal => {
      // activeTab.value = String(newVal)
      handleTabChange(newVal);
    });

    // 定义向父组件传递的事件
    const emit = __emit;
    const tabsWrapRef = ref(null);

    // PC端鼠标拖动实现
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let navContainer = null;
    const handleMouseDown = e => {
      if (e.button !== 0) return;
      if (!navContainer) {
        navContainer = tabsWrapRef.value?.querySelector('.van-tabs__nav');
      }
      if (!navContainer) return;
      isDragging = true;
      startX = e.pageX - navContainer.offsetLeft;
      scrollLeft = navContainer.scrollLeft;
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseMove = e => {
      if (!isDragging || !navContainer) return;
      e.preventDefault();
      const x = e.pageX - navContainer.offsetLeft;
      const walk = (x - startX) * 1.5;
      navContainer.scrollLeft = scrollLeft - walk;
    };
    const handleMouseUp = () => {
      isDragging = false;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    onMounted(() => {
      if (tabsWrapRef.value) {
        tabsWrapRef.value.addEventListener('mousedown', handleMouseDown);
      }
      // // 初始化完成后设置标志位
      setTimeout(() => {
        isInitialized.value = true;
      }, 1000);
    });
    onUnmounted(() => {
      if (tabsWrapRef.value) {
        tabsWrapRef.value.removeEventListener('mousedown', handleMouseDown);
      }
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    });
    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "tabs-wrap",
        ref_key: "tabsWrapRef",
        ref: tabsWrapRef
      }, [_createVNode(_component_van_tabs, {
        active: activeTab.value,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => activeTab.value = $event),
        "title-active-color": "#2bb061",
        color: "#2bb061",
        "line-width": "260px"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.serviceList, item => {
          return _openBlock(), _createBlock(_component_van_tab, {
            key: item.id,
            scrollable: "",
            name: String(item.id)
          }, {
            title: _withCtx(() => [_createElementVNode("img", {
              src: _unref(getServerImage)(item.img),
              alt: item.name,
              draggable: false
            }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1)]),
            _: 2
          }, 1032, ["name"]);
        }), 128))]),
        _: 1
      }, 8, ["active"])], 512), __props.showContent ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "content-wrap",
        innerHTML: remark.value
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true)]);
    };
  }
};